import styled from 'styled-components';

export const SectionContainer = styled.header<{ $hasNoCenter?: boolean }>`
  position: relative;

  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: ${({ $hasNoCenter }) => ($hasNoCenter ? 'start' : 'center')};
  justify-content: ${({ $hasNoCenter }) => ($hasNoCenter ? 'start' : 'center')};
  align-items: center;

  background-color: #f3fcfe;
  font-family: proxima-nova, sans-serif;
  overflow-x: clip;
  z-index: 1;
  margin-bottom: 4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    position: static;
    height: 520px;
    grid-template-columns: 1fr;
  }
`;

export const TextWrapper = styled.p<{
  color?: string;
  $extraPadding?: boolean;
  $hasNoCenter?: boolean;
}>`
  justify-items: start;
  text-align: left;

  padding: ${({ $extraPadding }) =>
    $extraPadding ? '6rem 17rem' : '6rem 16rem'};
  margin-left: ${({ $hasNoCenter }) => ($hasNoCenter ? '8rem' : '0')};
  max-width: 69.4rem;
  z-index: 1;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 6rem 2rem;
    width: 90%;
  }
`;

export const TitleWrapper = styled.div<{ noMarginBottom?: boolean }>`
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0' : '3rem')};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0' : '5rem')};
  }
`;

export const TitleText = styled.span<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size55};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height115};
  padding-bottom: 2rem;
  z-index: 2;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    color: ${({ color, theme }) => color || theme.color.white};
    font-size: ${({ theme }) => theme.fontSize.size40};
    width: 100%;
  }
`;

export const LabelText = styled.h5`
  color: ${({ color, theme }) => color || theme.color.mobilityBlue};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size24};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  margin-bottom: 3rem;
  z-index: 2;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    color: ${({ theme }) => theme.color.white};
    font-size: ${({ theme }) => theme.fontSize.size20};
  }
`;

export const ClippedImageWrapper = styled.div`
  position: relative;
  aspect-ratio: 2 / 1.3; // Or tweak as needed for your layout
  width: 100%;
  max-height: 680px;
  overflow: visible;
  z-index: 0;

  margin-bottom: -80px; // push it outside the container

  mask-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'>\
    <polygon points='0,0 100,0 100,80 20,100 15,100' fill='white' />\
  </svg>");
  mask-size: 100% 100%;
  mask-repeat: no-repeat;

  -webkit-mask-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'>\
    <polygon points='0,0 100,0 100,80 15,100 15,100' fill='white' />\
  </svg>");
  -webkit-mask-size: 100% 100%;
  -webkit-mask-repeat: no-repeat;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    max-height: 630px;
    z-index: 0;

    mask-image: url("data:image/svg+xml;utf8,\
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'>\
        <polygon points='-40,20 100,0 100,80 15,100 15,100' fill='white' />\
      </svg>");

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        rgba(23, 40, 57, 0.8) 0%,
        rgba(23, 40, 57, 0.4) 50%,
        rgba(23, 40, 57, 0.2) 80%,
        transparent 100%
      );
      z-index: 1;
      border-bottom-left-radius: 3rem;
      pointer-events: none;
    }
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-bottom-left-radius: 3rem;
  display: block;
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-bottom-left-radius: 3rem;
  display: block;
`;

export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 159, 227, 0.5);
  border-bottom-left-radius: 3rem;
  z-index: 1;
`;
